export default "__VITE_ASSET__4019d01c__"